import {connect} from 'react-redux'
import {
  getQueryAutocompletePlacesActionCreator,
  getQueryDetailsPlacesActionCreator,
} from 'data/redux/actions/guiActions';
import AutoCompletePlacesSelector
  from 'gui/components/editors/hotelEditor/components/hotelDetailsForm/components/hotelDetails/components/autoCompletePlacesSelector';
import {IPlaceDetails, IPrediction, IPredictionFormatted} from 'data/interfaces/products';


const mapStateToProps = (state, {label, field}) => {
  return {label, field};
};

const mapDispatchToProps = (dispatch) => {
  return {
    queryPlaces: (query: string): Promise<IPredictionFormatted[]> => dispatch(getQueryAutocompletePlacesActionCreator(query))
      .then((predictions: IPrediction[]) =>
        predictions
          .filter(prediction => prediction.terms.length >= 3)
          .map(({description, place_id, terms}) => ({
            label: description,
            value: {
              place_id,
              name: description,
              country: terms[terms.length - 1].value,
              city: terms[terms.length - 2].value,
              street: terms[terms.length - 3].value,
            }
          }))),
    queryPlaceDetails: (place_id: string) => dispatch(getQueryDetailsPlacesActionCreator(place_id)) as Promise<IPlaceDetails>
  };
};

const AutoCompletePlacesSelectorContainer = connect(mapStateToProps, mapDispatchToProps)(AutoCompletePlacesSelector as any);

export default AutoCompletePlacesSelectorContainer;
